import React, { Component } from 'react';
import { fetchConfigurationSetAppData, refreshConfigurationSets } from '../store/appData';
import { withTranslation } from 'react-i18next';
import { withStyles, Grid } from '@material-ui/core';
import axios from 'axios'
import Backdrop from '../../../common/components/UI/Backdrop/Backdrop';
import Snackbar from '../../../common/components/UI/Snackbar/Snackbar';
import CustomButton from '../../../common/components/UI/Button/Button';
import SearchInput from '../../../common/components/UI/Search/SearchInput';
import SideBar from '../../../common/components/UI/SideBar/SideBar';
import SimpleDialog from '../../../common/components/UI/Dialog/SimpleDialog';
import SuccesAnimated from '../../../common/components/UI/SuccessAnimated/SuccessAnimated'
import Form from '../components/Form';
import ConfigurationSetTable from '../components/ConfigurationSetTable';
import * as aux from "../../auxilaries";
import { currentHttpOptions, formatResponse } from '../../utils'
import { AdminSidePanelActionNames, PrivateEmployeeSource, PtoActionOnRejection, RequestSubtypeNames, RequestTypeNames, RuleSetType } from '../../Enums';
import { connect } from 'react-redux';

/**
 * @typedef {typeof AdminSidePanelActionNames[keyof AdminSidePanelActionNames]} IAdminSidePanelActionNames
 */

const styles = {
    content: {
        flexGrow: 1,
    },
    topButtonsContainer: {
        display: 'flex',
    },
    sideBar: {
        width: 720,
    },
    modalText: {
        width: '100%',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16,
        color: '#3A3A3A'
    }
};

class EBAdminSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openForm: false,
            sideAction: '',
            displaySpinner: true,
            settingList: [],
            filteredsettingList: [],
            hyperFindList: [],
            workRuleList: [],
            segmentTagsList: [],
            payCodeList: [],
            sortBySelected: '',
            sortOrder: 'Ascending',
            actionTypeList: [
                { label: "To Cover", value: 0 },
                { label: "Shift Swap", value: 1 },
                { label: "Open Shift", value: 2 },
                { label: "Voluntary Time Off", value: 3 }
            ],
            showDeleteDialog: false,
            showArchiveDialog: false,
            responseStatus: '',
            showResponseDialog: '',
            settingSelected: {},
            responseStatusText: '',
            searchValue: '',
            typeSnackbar: 'success',
            messageSnackbar: '',
            openSnackbar: false,
            timePeriodRatioOptions: [],
            privateEmployeeSources: [
                {label: "Manager Home Location", value: PrivateEmployeeSource.ManagerHomeLocation},
                {label: "Hyperfind", value: PrivateEmployeeSource.Hyperfind},
            ],
            ptoActionOnRejectionOptions: [],
            breakRuleList: []
        }
    }

    async componentDidMount(){
        const { isConfigurationSetAppDataLoaded, fetchConfigurationSetAppData } = this.props;
        if (!isConfigurationSetAppDataLoaded) {
            await fetchConfigurationSetAppData();
        }

        const {
            settingList, hyperFindList, segmentTagsList, workRuleList, dataviews, payCodeList, awardingRulesList, genericNotificationList, timePeriodRatioOptions, breakRuleList
        } = this.props;
        const { t } = this.props;
        const unarchivedSettings = settingList.filter(x => !x.isArchive);
        await this.setState({
            settingList: unarchivedSettings,
            filteredsettingList: unarchivedSettings,
            hyperFindList: hyperFindList,
            segmentTagsList: segmentTagsList,
            workRuleList: workRuleList,
            dataviewList: formatResponse(dataviews, 'id', true),
            payCodeList: payCodeList,
            awardingRulesList: awardingRulesList,
            genericNotificationList: genericNotificationList,
            timePeriodRatioOptions: timePeriodRatioOptions,
            displaySpinner: false,
            breakRuleList: breakRuleList,
            ptoActionOnRejectionOptions: [
                { label: t("settings.ptoActionOnRejectionOptions.submitted"), value: PtoActionOnRejection.Submitted },
                { label: t("settings.ptoActionOnRejectionOptions.refused"), value: PtoActionOnRejection.Refused },
                { label: t("settings.ptoActionOnRejectionOptions.cancelled"), value: PtoActionOnRejection.Cancelled },
            ],
        }, () => this.handleSearchFilter());
    }

    handleRefreshSettings = async () => {
        const { refreshConfigurationSets } = this.props;
        await refreshConfigurationSets();

        const { settingList } = this.props;
        const unarchivedSettings = settingList.filter(x => !x.isArchive);
        
        await this.setState({
            settingList: unarchivedSettings,
            filteredsettingList: unarchivedSettings,
        }, () => this.handleSearchFilter());
    }

    closeResponseDialog = () => {
        setTimeout(() => {
            this.setState({ showResponseDialog: false })
        }, 3000)
    }

    handleSubmitForm = (form) => {
        const { t } = this.props
        const { settingSelected, settingList, sideAction } = this.state;
        this.displaySpinner(true);
        const options = currentHttpOptions();
        if (sideAction === AdminSidePanelActionNames.Edit) {
            return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/admin/adminSettings/UpdateSetting', {
                ...form,
                AdminSettingsId: settingSelected.id
            }, options).then((response) => {
                let responseStatusText = t('admin.successEdit');
                const updatedSettingList = settingList.map(x => {
                    if (x.id === settingSelected.id) {
                        return response.data;
                    }
                    return x;
                })
                this.setState({
                    responseStatus: 'success',
                    showResponseDialog: true,
                    responseStatusText: responseStatusText,
                    settingSelected: {},
                    settingList: updatedSettingList,
                    filteredsettingList: updatedSettingList,
                })

                this.closePanelHandler();
                this.handleRefreshSettings();
            }).catch(err => {
                this.handleSnackbar('error', err.response.data.Message, true);
            }).finally(() => {
                this.displaySpinner(false);
                this.closeResponseDialog();
                this.handleSearchFilter()
            })
        }

        return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/admin/adminSettings/AddSetting', form, options).then(() => {
            let responseStatusText;

            if (sideAction === AdminSidePanelActionNames.Duplicate) {
                responseStatusText = t('admin.successDuplicate')
            } else {
                responseStatusText = t('admin.successCreate')
            }

            this.setState({
                responseStatus: 'success',
                showResponseDialog: true,
                responseStatusText: responseStatusText,
                settingSelected: {},
            })

            this.closePanelHandler();
            this.handleRefreshSettings();
        }).catch(err => {
            this.handleSnackbar('error', err.response.data.Message, true);
        }).finally(e => {
            this.displaySpinner(false);
            this.closeResponseDialog();
            this.handleSearchFilter()
        })
    }

    displaySpinner = (displaySpinner) => {
        this.setState({ displaySpinner })
    }

    handleSnackbar = (type, message, openState) => {
        this.setState({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    closeSnackbar = () => {
        setTimeout(() => {
            this.setState({ openSnackbar: false });
        }, 5000)
    }

    closePanelHandler = () => {
        this.setState({ openForm: false })
    }

    compareString = (a, b) => {
        var x,y;
        if(this.state.sortBySelected === "actionType") {
            x = a[this.state.sortBySelected] != null ? RequestTypeNames[a[this.state.sortBySelected]].toString().toLowerCase() : '';
            y = b[this.state.sortBySelected] != null ? RequestTypeNames[b[this.state.sortBySelected]].toString().toLowerCase() : '';
        }else if( this.state.sortBySelected === "requestSubtype"){
            x = a[this.state.sortBySelected] != null ? RequestSubtypeNames[a[this.state.sortBySelected]].toString().toLowerCase() : '';
            y = b[this.state.sortBySelected] != null ? RequestSubtypeNames[b[this.state.sortBySelected]].toString().toLowerCase() : '';
        } else if(this.state.sortBySelected === "creationHyperfindId") {
            const hyperfindA = this.state.hyperFindList.find(h => h.value === a[this.state.sortBySelected]);
            const hyperfindB = this.state.hyperFindList.find(h => h.value === b[this.state.sortBySelected]);
            x = hyperfindA ? hyperfindA.label.toString().toLowerCase() : '';
            y = hyperfindB ? hyperfindB.label.toString().toLowerCase() : '';
        } else if(this.state.sortBySelected === "managementHyperfindId") {
            const hyperfindA = this.state.hyperFindList.find(h => h.value === a[this.state.sortBySelected]);
            const hyperfindB = this.state.hyperFindList.find(h => h.value === b[this.state.sortBySelected]);
            x = hyperfindA ? hyperfindA.label.toString().toLowerCase() : '';
            y = hyperfindB ? hyperfindB.label.toString().toLowerCase() : '';
        } else{
            x = a[this.state.sortBySelected] != null ? a[this.state.sortBySelected].toString().toLowerCase() : '';
            y = b[this.state.sortBySelected] != null ? b[this.state.sortBySelected].toString().toLowerCase() : '';
        }
        if (x < y) { return -1; }
        if (x > y) { return 1; }
        return 0;
    }

    sortBy = (sortIndex) => {
        var oldSortBy = this.state.sortBySelected;
        this.setState({ sortBySelected: sortIndex },
            () => {
                if (oldSortBy === sortIndex) {
                    let sortOrder = this.state.sortOrder === 'Ascending' ? 'Descending' : 'Ascending'
                    this.setState({ settingList: this.state.settingList.reverse(), sortOrder });
                } else {
                    let sortOrder = this.state.sortOrder === 'Ascending' ? 'Descending' : 'Ascending'
                    this.setState({ settingList: this.state.settingList.sort(this.compareString), sortOrder });
                }
            }
        )
    }

    cancelAction = () => {
        this.setState({
            openForm: false,
            showDeleteDialog: false,
            showArchiveDialog: false,
            sideAction: '',
            spinnerShow: false,
        })
    }

    /**
     * @param {IAdminSidePanelActionNames} sideAction 
     * @param {*} settingSelected 
     */
    rightPanelHandler = (sideAction, settingSelected) => {
        /** @type {typeof this.state} */
        let state = {
            sideAction,
            settingSelected,
        };

        switch (sideAction) {
            case AdminSidePanelActionNames.Delete:
                state = {
                    ...state,
                    showDeleteDialog: true,
                };
                break;
            case AdminSidePanelActionNames.Archive:
                state = {
                    ...state,
                    showArchiveDialog: true,
                };
                break;
            default:
                state = {
                    ...state,
                    openForm: true,
                };
            break;
        }

        this.setState(state);
    }

    deleteItem = async () => {
        const { t } = this.props
        const { settingSelected, settingList } = this.state
        const options = currentHttpOptions()
        let message = '';
        this.displaySpinner(true)
        let deleteAction = await axios.delete(process.env.REACT_APP_API_DOTNET + '/api/v1/admin/adminSettings/DeleteSetting/' + settingSelected.id, options)
            .catch(err => {
                message = aux.handleAPIErrors(err.response)
            }).finally(() => {
                this.displaySpinner(false)
            });
        let settingListAux = settingList.filter((element) => element.id !== settingSelected.id)
        if (!deleteAction) { //deleteAction is undefined
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: message,
                settingSelected: {},
                showDeleteDialog: false,
            })
        }
        else if (typeof deleteAction.data.error === 'undefined') {
            this.setState({
                settingList: settingListAux,
                filteredsettingList: settingListAux,
                responseStatus: 'success',
                showResponseDialog: true,
                responseStatusText: t('admin.successDelete'),
                settingSelected: {},
                showDeleteDialog: false,
            })
        }
        else {
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: typeof deleteAction.data.error !== 'undefined' ? deleteAction.data.error : deleteAction.data,
                settingSelected: {},
                showDeleteDialog: false,
            })
        }
        this.displaySpinner(false)
        this.closeResponseDialog()
        this.handleSearchFilter()
    }

    archiveItem = async () => {
        const { t } = this.props
        const { settingSelected: { id: adminSettingId }, settingList } = this.state
        const options = currentHttpOptions()
        let message = '';
        this.displaySpinner(true)
        const url = `${process.env.REACT_APP_API_DOTNET}/api/v1/admin/adminSettings/archive/${adminSettingId}`;
        let archiveAction = await axios.put(url, {}, options)
            .catch(err => {
                message = aux.handleAPIErrors(err.response)
            }).finally(() => {
                this.displaySpinner(false)
            });
        let settingListAux = settingList.filter((element) => element.id !== adminSettingId)
        if (!archiveAction) { //archiveAction is undefined
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: message,
                settingSelected: {},
                showArchiveDialog: false,
            })
        }
        else if (typeof archiveAction.data.error === 'undefined') {
            this.setState({
                settingList: settingListAux,
                filteredsettingList: settingListAux,
                responseStatus: 'success',
                showResponseDialog: true,
                responseStatusText: t('settings.successArchived'),
                settingSelected: {},
                showArchiveDialog: false,
            })
            this.handleRefreshSettings();
        }
        else {
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: typeof archiveAction.data.error !== 'undefined' ? archiveAction.data.error : archiveAction.data,
                settingSelected: {},
                showArchiveDialog: false,
            })
        }
        this.displaySpinner(false)
        this.closeResponseDialog()
        this.handleSearchFilter()
    }

    handleSearchFilter = (event) => {
        const { searchValue, settingList } = this.state;
        const searchableFields = ['name', 'creationHyperfindId', 'managementHyperfindId', 'description']

        let filteredSettings = [];

        let searchFilter = event === undefined ? searchValue : (event.target.value === undefined) ? searchValue : event.target.value;

        if (searchFilter !== '') {
            for (const setting of settingList) {
                for (const key in setting) {
                    if (searchableFields.includes(key)
                        && setting[key] !== null
                        && setting[key].toString().toLowerCase().includes(searchFilter.toLowerCase())) {
                        filteredSettings.push(setting)
                        break;
                    }
                }
            }
        } else {
            filteredSettings = settingList;
        }

        this.setState({
            searchValue: searchFilter,
            filteredsettingList: filteredSettings,
        })
    }
    render() {
        const { classes, t, breRuleSetList } = this.props;
        const {
            actionTypeList, awardingRulesList, dataviewList, displaySpinner, filteredsettingList,
            genericNotificationList, hyperFindList, messageSnackbar, openForm, openSnackbar, payCodeList, responseStatus,
            responseStatusText, searchValue, segmentTagsList, settingList, settingSelected, showArchiveDialog, showDeleteDialog,
            showResponseDialog, sideAction, sortBySelected, sortOrder, timePeriodRatioOptions, typeSnackbar, workRuleList, privateEmployeeSources,
            ptoActionOnRejectionOptions,
            breakRuleList,
        } = this.state;

        const updatedFilteredListSettings = filteredsettingList.map((setting) => {
            const matchingBreRule = breRuleSetList.find(rule => rule.id === setting.breRuleSetId);
            const matchingAwardingRule = awardingRulesList.find(awarding => awarding.id === setting.awardingRuleId)
            return {
                ...setting,
                breRuleSetName: matchingBreRule ? matchingBreRule.name : null,
                awardingRuleName: matchingAwardingRule ? matchingAwardingRule.name : null,
            };
        });
        

        const formTitle = sideAction === AdminSidePanelActionNames.Edit
            ? t('settings.adminSidePanelHeaderEdit')
            : t('settings.adminSidePanelHeader');

        let header = (
            <React.Fragment>
                <Grid container>
                    <Grid className={classes.topButtonsContainer} item xs={3} >
                        <CustomButton
                            size={'medium'}
                            color={'primary'}
                            onClick={() => {
                                this.setState({
                                    sideAction: AdminSidePanelActionNames.Create,
                                    openForm: true
                                })
                            }}
                        >
                            {t('settings.addNew')}
                        </CustomButton>
                    </Grid>
                    <Grid item xs={3} ></Grid>
                    <Grid className={classes.topButtonsContainer} item xs={6} >
                        <SearchInput
                            fullWidth={true}
                            value={searchValue}
                            placeholder={t('settings.search')}
                            onChange={this.handleSearchFilter}
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        )
        
        let success = showResponseDialog ?
            <SuccesAnimated
                type={responseStatus}
                open={showResponseDialog}
                handleClose={() => { this.setState({ showResponseDialog: false }) }}>
                <div className={classes.modalText}>{responseStatusText}</div>
            </SuccesAnimated> : '';

        const deleteContentText = t('settings.deleteContent', { configurationType: t('configurationTypes.setup').toLowerCase() });
        const archiveContentText = t('settings.archiveContent', { configurationType: t('configurationTypes.setup').toLowerCase() });

        return (
            <section className={classes.content}>
                {header}
                <ConfigurationSetTable
                    className={classes.displayFlex}
                    sortBySelected={sortBySelected}
                    sortBy={this.sortBy}
                    sortOrder={sortOrder}
                    filteredsettingList={updatedFilteredListSettings}
                    dateFormat={this.props.dateFormat}//TODO 2023/05/05 - kathy - Use user date format set on hris
                    hyperfinds={hyperFindList}
                    rightPanelHandler={this.rightPanelHandler}
                />
                <SideBar
                    className={classes.sideBar}
                    handleDrawerClose={this.closePanelHandler}
                    open={openForm}
                    title={formTitle}
                    isCloseOnOutsideClick={false}
                >
                    <Form
                        action={sideAction}
                        actionTypeList={actionTypeList}
                        awardingRulesList={awardingRulesList}
                        breRuleSetList={breRuleSetList}
                        cancel={this.cancelAction}
                        dataviewList={dataviewList}
                        genericNotificationList={genericNotificationList}
                        handleSubmitForm={this.handleSubmitForm}
                        hyperFindList={hyperFindList}
                        payCodeList={payCodeList}
                        segmentTagsList={segmentTagsList}
                        settingList={settingList}
                        settingSelected={settingSelected}
                        timePeriodRatioOptions={timePeriodRatioOptions}
                        workRuleList={workRuleList}
                        privateEmployeeSources={privateEmployeeSources}
                        ptoActionOnRejectionOptions={ptoActionOnRejectionOptions}
                        breakRuleList={breakRuleList}
                    />
                </SideBar>
                <Backdrop
                    showSpinner={displaySpinner}
                    showback={true}
                />
                <Snackbar
                    type={typeSnackbar}
                    message={messageSnackbar}
                    open={openSnackbar}
                    closeSnackbar={this.closeSnackbar}
                    bodyStyle={{ whiteSpace: 'pre-line' }}
                />
                <SimpleDialog
                    open={showDeleteDialog}
                    title={t('settings.delete')}
                    contentText={deleteContentText}
                    submit={this.deleteItem}
                    cancel={this.cancelAction}
                />
                <SimpleDialog
                    open={showArchiveDialog}
                    title={t('settings.archive')}
                    contentText={archiveContentText}
                    submit={this.archiveItem}
                    cancel={this.cancelAction}
                />
                {success}
            </section>
        );
    }
}

const mapStateToProps = state => {
    return {
        settingList: state.adminAppData.settingList,
        hyperFindList: state.adminAppData.hyperfinds,
        segmentTagsList: state.adminAppData.segmentTagsList,
        breRuleSetList: state.adminAppData.breRuleSetList,
        workRuleList: state.adminAppData.workRuleList,
        dataviews: state.adminAppData.dataviews,
        payCodeList: state.adminAppData.payCodeList,
        awardingRulesList: state.adminAppData.awardingRulesList,
        genericNotificationList: state.adminAppData.genericNotificationList,
        timePeriodRatioOptions: state.adminAppData.timePeriodRatioOptions,
        isConfigurationSetAppDataLoaded: state.adminAppData.isConfigurationSetAppDataLoaded,
        breakRuleList: state.adminAppData.breakRuleList,
    };
  };
  
const mapDispatchToProps = dispatch => {
    return {
        fetchConfigurationSetAppData: () => dispatch(fetchConfigurationSetAppData()),
        refreshConfigurationSets: () => dispatch(refreshConfigurationSets()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withTranslation(['employmentBillboard'])(EBAdminSettings)));
